export const isCards = (data: any) => {
    for (const item of data) {
        if (item.children) {
            return true
        }
    }
    return false
}